<template>
    <vs-card class="cstm_vx_card content_mb_0 mb-0">
        <div slot="header" class="flex flex-wrap justify-between items-center">
                    <h4>User Timeline</h4>
                    <!-- <vs-dropdown>
                        <vs-button class="btn-drop" type="flat" icon="more_vert"></vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item>
                                Edit
                            </vs-dropdown-item>
                            <vs-dropdown-item>
                                Delete
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown> -->
                </div>
                <div style="height: 200px; overflow-y: auto;" class="vertical_scrollbar">
                  <div style="padding: 1.5rem;">
                    <!-- <ul class="timeline_ul_holder"> -->
                    <ul class="vx-timeline">
                        <li v-for="(item,index) in timelineData" :key="index">
                          <div :class="`timeline-icon ${ item.activity_type }`">
                            <vs-tooltip :text="item.activity_type" color="primary">
                              <span :class="`material-icons-outlined ${ item.activity_type }-text`">
                                {{ renderIcon (item.activity_type) }}
                              </span>
                            </vs-tooltip>
                          </div>

                          <div class="timeline-info">
                            <div class="flex w-full justify-between">
                              <div>
                                <p class="font-semibold">{{ getDescription(item) }}</p>
                                <p class="text-muted">Invoices have been paid to the company</p>
                              </div>
                              <small class="text-grey activity-e-time">{{ item.created_at | formatTimeAgo }}</small>
                            </div>
                          </div>

                            <!-- <div>
                                <strong>{{getDescription(item)}}</strong>
                                <p class="text-muted">Invoices have been paid to the company</p>
                            </div>
                            <p class="text-muted">{{item.created_at | formatTimeAgo}}</p> -->
                        </li>
                    </ul>
                  </div>
                </div>

    </vs-card>
</template>
<script>
import { getActivityList } from '@/api/activityLog'

export default {
  mounted () {
    this.getActivityLog()
  },
  props: ['student_id', 'new_activity'],
  watch: {
    student_id (new_value) {
      this.studentId = new_value
      this.timelineData = []
      this.timelineMeta = {
        total: null,
        limit: null,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: null
      }

      this.getActivityLog()
    },
    new_activity (new_value) {
      this.timelineData.unshift({ ...new_value })
    }
  },
  data () {
    return {
      studentId: this.student_id,
      timelineData: [],
      timelineMeta: {
        total: null,
        limit: null,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: null
      }
    }
  },
  methods: {
    renderIcon (activity_type) {
      const iconSet = [
        { type: 'Create', icon: 'contacts' },
        { type: 'Edit', icon: 'edit' },
        { type: 'enroll', icon: 'badge' }
      ]

      return iconSet.find(activity => activity.type === activity_type).icon
    },
    getDescription (item) {
      const action_person_name = `${item.user_details.first_name} ${item.user_details.middle_name} ${item.user_details.last_name}`

      if (item.activity_type === 'Create') {
        return `Student has been created by ${action_person_name}`
      } else if (item.activity_type === 'Edit') {
        return `Student has been edited by ${action_person_name}`
      } else if (item.activity_type === 'CertificateShare') {
        return `Certificate has been shared by ${action_person_name}`
      } else if (item.activity_type === 'ShareGradebook') {
        return `Gradebook has been shared by ${action_person_name}`
      } else {
        return item.description
      }
    },
    async getActivityLog () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.studentId,
        platform_module_id: 4
      }

      try {
        const response = await getActivityList(payload)
        this.timelineData = response.data.data.activity
        this.timelineMeta = response.data.data.meta

      } catch (e) {
        console.log(e)
      }
    },
    async getMoreActivityLog ($state) {
      if (this.timelineMeta.has_next) {
        const payload = {
          customer_id: localStorage.getItem('customer_id'),
          entity_id: this.studentId,
          platform_module_id: 4
        }
        
        try {
          const response = await getActivityList(payload, this.timelineMeta.next_page_url)
          this.timelineData.push(...response.data.data.activity)
          this.timelineMeta = response.data.data.meta

          if (!this.timelineMeta.has_next) {
            $state.complete()
          } else {
            $state.loaded()
          }
        } catch (e) {
          console.log(e)
        }
      } else  {
        $state.complete()
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>